"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const colors_1 = require("../../shared/constants/colors");
exports.default = ({ translations }) => {
    return ((0, jsx_runtime_1.jsxs)(BodyContainer, { children: [(0, jsx_runtime_1.jsx)(SectionWrapper, { horizontalFlex: "center", children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ["fas", "wifi-slash"], size: "3x", color: colors_1.colors.yellowBase }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)(ContentWrapper, { children: [(0, jsx_runtime_1.jsx)(SectionWrapper, { noWrap: true, horizontalFlex: "flex-start", children: translations.noInternet }, void 0), (0, jsx_runtime_1.jsx)(SectionWrapper, { horizontalFlex: "flex-start", children: translations.actions }, void 0), (0, jsx_runtime_1.jsx)(SectionWrapper, { horizontalFlex: "flex-start", children: translations.tryLater }, void 0)] }, void 0)] }, void 0));
};
const BodyContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 30px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const SectionWrapper = styled_components_1.default.div `
  display: flex;
  margin-bottom: 20px;
  min-width: fit-content;
  ${({ noWrap }) => noWrap ? "white-space:nowrap; overflow: hidden;" : ""}
  ${({ verticalFlex }) => verticalFlex ? "align-items: " + verticalFlex : ""}
  ${({ horizontalFlex }) => horizontalFlex ? "justify-content: " + horizontalFlex : ""}
`;
const ContentWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 400px;
  justify-content: center;
`;
//# sourceMappingURL=OfflineInfoCard.js.map